module.exports = __webpack_public_path__ + "img/16.41418aa0.jpg";